import { render, staticRenderFns } from "./courseModal.vue?vue&type=template&id=7855cddc&scoped=true&"
import script from "./courseModal.vue?vue&type=script&lang=js&"
export * from "./courseModal.vue?vue&type=script&lang=js&"
import style0 from "./courseModal.vue?vue&type=style&index=0&id=7855cddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855cddc",
  null
  
)

export default component.exports